export default {
    LOGIN_FAILURE: 'Hmm... The email and password you entered don’t match our records. You can reset your password or try again.',
    PASSWORD_MISMATCH: 'Passwords don\'t match. Please try again.',
    USER_ALREADY_EXISTS: 'The email you entered is already is use, please try to log in again or use another email.',
    FIELDS_REQUIRED: 'All fields are required to create an account with Assembled Brands. Please try again.',
    UNKNOWN_ERROR: 'An error has occurred. Please try again later.',
    INVALID_EMAIL: 'Invalid email, please provide a valid address where we can reach you.'
}